import { enc, SHA256 } from "crypto-js";

const generateShortHash = (inputString: string) => {
  const hash = SHA256(inputString);
  const shortHash = hash.toString(enc.Hex).substr(0, 12);
  return shortHash;
};

export async function createDeviceId() {
  const deviceId = generateShortHash(Date.now().toString());
  localStorage.setItem("deviceId", deviceId);
  return deviceId;
}